/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkupV2StateResponse
 */
export interface MarkupV2StateResponse {
    /**
     * 
     * @type {string}
     * @memberof MarkupV2StateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2StateResponse
     */
    errorMessage?: string | null;
}

export function MarkupV2StateResponseFromJSON(json: any): MarkupV2StateResponse {
    return MarkupV2StateResponseFromJSONTyped(json, false);
}

export function MarkupV2StateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2StateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function MarkupV2StateResponseToJSON(value?: MarkupV2StateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


